/* ATHLETIX category carousel — native scroll, desktop arrows and mobile touch swipe. */
(() => {
  const widgetFor = (element) => element?.closest?.('[data-athcat-carousel]');
  const sync = (widget) => {
    const track = widget?.querySelector('[data-athcat-track]');
    if (!track) return;
    const prev = widget.closest('.athcat')?.querySelector('[data-athcat-scroll="prev"]');
    const next = widget.closest('.athcat')?.querySelector('[data-athcat-scroll="next"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const syncAll = () => document.querySelectorAll('[data-athcat-carousel]').forEach(sync);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-athcat-scroll]');
    if (!button || button.disabled) return;
    const section = button.closest('.athcat');
    const track = section?.querySelector('[data-athcat-track]');
    if (!track) return;
    const first = track.querySelector('.athcat__card');
    if (!first) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const delta = first.getBoundingClientRect().width + gap;
    track.scrollBy({ left: (button.dataset.athcatScroll === 'next' ? 1 : -1) * delta,
                     behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });

  document.addEventListener('scroll', (event) => {
    if (event.target?.matches?.('[data-athcat-track]')) sync(widgetFor(event.target));
  }, true);
  window.addEventListener('resize', syncAll, {passive:true});
  document.addEventListener('shopify:section:load', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, {once:true});
  else syncAll();
})();
